export {default as queue} from "./src/queue";



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-queue/index.js
// module id = ../../../../d3-queue/index.js
// module chunks = 3